export const API_URL="https://m2m-api.ekomobile.ru"
